/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlAppCoreEnumsAuth0Roles } from './ControlAppCoreEnumsAuth0Roles';
import {
    ControlAppCoreEnumsAuth0RolesFromJSON,
    ControlAppCoreEnumsAuth0RolesFromJSONTyped,
    ControlAppCoreEnumsAuth0RolesToJSON,
} from './ControlAppCoreEnumsAuth0Roles';
import type { ControlOnboardingActionItems } from './ControlOnboardingActionItems';
import {
    ControlOnboardingActionItemsFromJSON,
    ControlOnboardingActionItemsFromJSONTyped,
    ControlOnboardingActionItemsToJSON,
} from './ControlOnboardingActionItems';

/**
 * 
 * @export
 * @interface ControlPostTestingUser
 */
export interface ControlPostTestingUser {
    /**
     * 
     * @type {boolean}
     * @memberof ControlPostTestingUser
     */
    onboarded?: boolean;
    /**
     * 
     * @type {Array<ControlOnboardingActionItems>}
     * @memberof ControlPostTestingUser
     */
    onboarding_action_items?: Array<ControlOnboardingActionItems>;
    /**
     * 
     * @type {ControlAppCoreEnumsAuth0Roles}
     * @memberof ControlPostTestingUser
     */
    role: ControlAppCoreEnumsAuth0Roles;
}

/**
 * Check if a given object implements the ControlPostTestingUser interface.
 */
export function instanceOfControlPostTestingUser(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "role" in value;

    return isInstance;
}

export function ControlPostTestingUserFromJSON(json: any): ControlPostTestingUser {
    return ControlPostTestingUserFromJSONTyped(json, false);
}

export function ControlPostTestingUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlPostTestingUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'onboarded': !exists(json, 'onboarded') ? undefined : json['onboarded'],
        'onboarding_action_items': !exists(json, 'onboarding_action_items') ? undefined : ((json['onboarding_action_items'] as Array<any>).map(ControlOnboardingActionItemsFromJSON)),
        'role': ControlAppCoreEnumsAuth0RolesFromJSON(json['role']),
    };
}

export function ControlPostTestingUserToJSON(value?: ControlPostTestingUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'onboarded': value.onboarded,
        'onboarding_action_items': value.onboarding_action_items === undefined ? undefined : ((value.onboarding_action_items as Array<any>).map(ControlOnboardingActionItemsToJSON)),
        'role': ControlAppCoreEnumsAuth0RolesToJSON(value.role),
    };
}

